import { render, staticRenderFns } from "./ProductNameImport.vue?vue&type=template&id=d7b3e626&scoped=true&"
import script from "./ProductNameImport.vue?vue&type=script&lang=js&"
export * from "./ProductNameImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b3e626",
  null
  
)

export default component.exports